import React from 'react';
import PropTypes from 'prop-types';

import UpdateZendeskTicket from 'containers/UpdateZendeskTicket';
import Layout, { Layouts } from 'containers/Layout';
import { withTranslation } from 'utils/with-i18next';

export class ListPropertyPage extends React.PureComponent {
  render() {
    const { t } = this.props;

    return (
      <Layout type={Layouts.GENERIC} byPassAuth={true} image={'listingBg'}>
        <UpdateZendeskTicket t={t} />
      </Layout>
    );
  }
}

ListPropertyPage.propTypes = {
  t: PropTypes.func,
};

ListPropertyPage.getInitialProps = async () => ({
  namespacesRequired: ['common', 'banner', 'features'],
});

export default withTranslation('common')(ListPropertyPage);
